import CronGenerator from 'components/CronGenerator/CronGenerator';
import Text from 'components/Text/Text';
import ActivationScheduleInput from './components/ActivationScheduleInput';
import DeactivationScheduleInput from './components/DeactivationScheduleInput';
import React, { useContext, useEffect } from 'react';
import {
	ICreateSubCategoryContext,
	CreateSubCategoryContext,
} from '../../../../../createSubCategoryState/createSubCategoryContext';
import { ISubCategoryRestaurants } from 'types';
import CustomerSelect from './components/CustomerSelect';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import NameSubCategoryInput from './components/NameSubCategoryInput';
import CategorySelect from './components/CategorySelect';
import RestaurantsToHideMultipleSelect from './components/RestaurantsToHideSelect/RestaurantsToHideMultipleSelect';
import RestaurantsAvailableForRepetitionSelect from './components/RestaurantsAvailableForRepetitionSelect/RestaurantsAvailableForRepetitionSelect';
import BtnBlock from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		changeNameOfSubCategory,
		setIDCategory,
		setFetchedCategories,
		setIDsOfRestaurantsWhereToHide,
		setIDsOfRestaurantsAvailableForRepetition,
		changeActivationSchedule,
		changeDeactivationSchedule,
		fileId,
		IDSelectedCustomer,
		fetchedRestaurants,
		IDsSelectedRestaurant,
		nameOfSubCategory,
		IDSelectedCategory,
		IDsOfRestaurantsWhereToHide,
		IDsOfRestaurantsAvailableForRepetition,
		activationSchedule,
		deactivationSchedule,
		translations,
		defaultCustomerLanguage,
	} = useContext<ICreateSubCategoryContext>(CreateSubCategoryContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedCustomer,
			IDsSelectedRestaurant,
			nameOfSubCategory,
			IDSelectedCategory,
			IDsOfRestaurantsWhereToHide,
			IDsOfRestaurantsAvailableForRepetition,
			activationSchedule,
			deactivationSchedule,
		});
	}, [
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfSubCategory,
		IDSelectedCategory,
		IDsOfRestaurantsWhereToHide,
		IDsOfRestaurantsAvailableForRepetition,
		activationSchedule,
		deactivationSchedule,
	]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		const finalSubCategoryRestaurants: ISubCategoryRestaurants[] = IDsSelectedRestaurant.map(
			(idSelectedRestaurant) => {
				const isHidden = IDsOfRestaurantsWhereToHide.find(
					(idRestaurantToHide) => idRestaurantToHide === idSelectedRestaurant,
				);
				const isAvailableForRepetition = IDsOfRestaurantsAvailableForRepetition.find(
					(idRestaurantAvailableForRepetition) => idRestaurantAvailableForRepetition === idSelectedRestaurant,
				);
				return {
					restaurantId: idSelectedRestaurant,
					isHidden: !!isHidden,
					isAvailableForRepetition: !!isAvailableForRepetition,
				};
			},
		);

		setDataForSubmit({
			fileId,
			customerId: IDSelectedCustomer || '',
			subCategoryRestaurants: finalSubCategoryRestaurants,
			name: nameOfSubCategory,
			categoryId: IDSelectedCategory,
			activationCron: activationSchedule,
			deactivationCron: deactivationSchedule,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<CustomerSelect setIDCustomer={setIDCustomer} setFetchedCustomers={setFetchedCustomers} />
					<RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						IDSelectedCustomer={IDSelectedCustomer}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
					<NameSubCategoryInput changeNameOfSubCategory={changeNameOfSubCategory} />
					<CategorySelect
						setIDCategory={setIDCategory}
						setFetchedCategories={setFetchedCategories}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="hideSubcategoryHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<RestaurantsToHideMultipleSelect
						setIDsOfRestaurantsWhereToHide={setIDsOfRestaurantsWhereToHide}
						IDSelectedCustomer={IDSelectedCustomer}
						fetchedRestaurants={fetchedRestaurants}
						IDsOfRestaurantsWhereToHide={IDsOfRestaurantsWhereToHide}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="availableForRepetitionHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<RestaurantsAvailableForRepetitionSelect
						setIDsOfRestaurantsAvailableForRepetition={setIDsOfRestaurantsAvailableForRepetition}
						IDSelectedCustomer={IDSelectedCustomer}
						fetchedRestaurants={fetchedRestaurants}
						IDsOfRestaurantsAvailableForRepetition={IDsOfRestaurantsAvailableForRepetition}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<ActivationScheduleInput changeActivationSchedule={changeActivationSchedule} />
						<DeactivationScheduleInput changeDeactivationSchedule={changeDeactivationSchedule} />
					</div>
					<CronGenerator />
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
